import React, {useContext, useEffect, useState} from 'react';
import {DispatchContext, StateContext} from '../../../store';
import Box from '@mui/material/Box';
import {Button} from '@mui/material';
import BorderColorRoundedIcon from '@mui/icons-material/BorderColorRounded';
import {deaccessionTaskPoolService} from '../../../services/DeaccessionServices';
import ClearIcon from '@mui/icons-material/Clear';
import DownloadDoneRoundedIcon from '@mui/icons-material/DownloadDoneRounded';
import {taskPoolServices} from '../../../services/TaskPoolServices';
import {SNACKBAR_OPEN} from '../../../reducers';
import RejectDeaccession from './RejectDeaccession';
import AcceptDeaccession from './AcceptDeaccession';

export default function DeaccessionAction({item, handleEdit, deaccessionId}) {
  const dispatch = useContext(DispatchContext);
  const {commonUpdate} = useContext(StateContext);
  const {role} = useContext(StateContext);
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState(false);
  const admin = role?.id === 1 || role?.id === 10;
  const curator = role?.id === 2;
  const requested = item?.state === 'requested';
  const approved = item?.state === 'approved';
  const rejected = item?.state === 'rejected';
  const resubmitted = item?.state === 'resubmitted';
  const [taskPool, setTaskPool] = useState([]);
  const poolId = taskPool?.map(value => value?.role_id);
  const roleId = role?.id;
  const isRoleIdInPool = poolId.includes(roleId);

  let taskPoolId = null;
  let taskPoolState = '';

  if (isRoleIdInPool) {
    const index = poolId.indexOf(roleId);

    if (index !== -1) {
      taskPoolId = taskPool[index]?.id;
      taskPoolState = taskPool[index]?.state;
    }
  }

  useEffect(() => {
    getTaskPool();
  }, [commonUpdate]);

  const getTaskPool = () => {
    deaccessionTaskPoolService('get', deaccessionId).then(res => {
      setTaskPool(res?.data);
    })
  }

  const handleReject = () => {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleAcceptAction = () => {
    setDisplay(true);
  }

  const handleCloseAction = () => {
    setDisplay(false);
  }

  const handleStartPool = () => {
    taskPoolServices('put', taskPoolId, {action: 'start'}).then(res => {
      dispatch({type: 'STATE', payload: {change: true}});
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Started successfully'}
      });
    });
  }

  return (
    <div>
      {item?.state &&
      <div>
        {(curator && requested) ? (
          <Box>
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#FF965B', '&:hover': {bgcolor: '#FF965B'}}}>Pending</Button>
          </Box>) : (curator && rejected) ? (
          <Box>
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#f6363c', '&:hover': {bgcolor: '#F6363C'}}}>Rejected</Button>
            <Button onClick={handleEdit}
                    startIcon={<BorderColorRoundedIcon/>} variant={'contained'}
                    sx={{mr: 2, bgcolor: '#009344'}}>Resubmit</Button>
          </Box>) : (curator && approved) ? (
          <Box>
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#009344', '&:hover': {bgcolor: '#009344'}}}>Approved</Button>
          </Box>
        ) : (<div/>)}
        {taskPoolState === 'in_progress' ?
          <div>
            {((admin && requested) || (admin && resubmitted)) && (
              <Box>
                <Button onClick={handleEdit}
                        startIcon={<BorderColorRoundedIcon/>} variant={'contained'}
                        sx={{mr: 2, bgcolor: '#009344'}}>Edit</Button>
                <Button onClick={handleReject} startIcon={<ClearIcon/>} variant={'contained'} color={'error'}
                        sx={{mr: 2}}>Reject</Button>
                <Button onClick={handleAcceptAction} startIcon={<DownloadDoneRoundedIcon/>}
                        variant={'contained'}>Approve</Button>
              </Box>
            )}
          </div> :
          <div>
            {(admin && taskPoolState === 'assigned') ?
              <Button onClick={handleStartPool} variant={'contained'} sx={{ml: 2}}>
                Start
              </Button> :
              <div>
                {taskPoolState &&
                <div>
                  <Button variant={'contained'} className={'shadow-none no-cursor'}
                          sx={{mr: 2, bgcolor: '#009344', '&:hover': {bgcolor: '#009344'}}}>
                    Approved</Button>
                </div>}
              </div>
            }
          </div>
        }
        {taskPoolState === 'in_progress' &&
          <div>
            {(admin && rejected) &&
            <Button variant={'contained'} className={'shadow-none no-cursor'}
                    sx={{mr: 2, bgcolor: '#F6363C', '&:hover': {bgcolor: '#F6363C'}}}>
              Rejected</Button>}
          </div>
        }
      </div>
      }
      {open &&
      <RejectDeaccession open={open} handleAction={handleClose} roleId={roleId} taskPool={taskPool}/>}
      {display &&
      <AcceptDeaccession open={display} handleAction={handleCloseAction} roleId={roleId} taskPool={taskPool}
                         deaccessionId={deaccessionId}/>}
    </div>
  );
}
